// Cover blocks


// Set the SVG color to match the background color of the cover block
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.wp-block-cover').forEach((cover) => {
		const bg = cover.querySelector('.wp-block-cover__background');
		const svg = cover.querySelector('.tick-circle-svg');

		if (bg) {
			const bgColor = window.getComputedStyle(bg).backgroundColor;
			cover.style.setProperty('--tick-circle-fill', bgColor);
		}

		// Check if the cover has a defined custom tick path stroke
		const computed = window.getComputedStyle(cover);
		const strokeColor = computed.getPropertyValue('--tick-line-stroke');

		if (strokeColor) {
			// Apply for linear styles (mask-based)
			cover.style.setProperty('--tick-line-stroke', strokeColor.trim());

			// Apply for SVG if present
			if (svg) {
				svg.style.setProperty('--tick-line-stroke', strokeColor.trim());
			}
		}
	});
});


